import { createSelector } from '@reduxjs/toolkit';
import { ReduxState } from '../../types';

export const userFavoritesSelector = (state: ReduxState) => {
    return state.user.userFavorites
};